import { TImage, TImageWithMetadata } from '@components/typescript';

const variantAlt = (variant: TImageWithMetadata | string | null | undefined): string => {
  if (!variant || typeof variant === 'string') return '';
  return variant.metadata?.alt?.trim() ?? '';
};

/** Jeden atrybut `alt` na `<img>`. Desktop ma pierwszeństwo, pusty opis spada na tablet i mobile. */
const GetImageAlt = (images: TImage) =>
  variantAlt(images?.desktop) || variantAlt(images?.tablet) || variantAlt(images?.mobile);

export default GetImageAlt;
